// TODO: add unit test -> https://pumaglobal.atlassian.net/browse/WEB-1655
export const sleep = (ms: number) => new Promise(res => setTimeout(res, ms));
